import { Component, Inject, OnInit } from '@angular/core';
import { HistoryService } from '../../services/history.service';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import { AlertService } from 'src/lib/ariadna/alert';
// import { ICalendarDateActive } from '../../interfaces/calendar';
// import * as moment from 'moment';

@Component({
    selector: 'app-history-item',
    templateUrl: './history-item.component.html',
    styleUrls: ['./history-item.component.scss'],
})
export class HistoryItemComponent implements OnInit {
    historyId: number = 0;
    historyType: string = '';
    resHtml: string | SafeHtml = '';
    pdfImageURL = 'assets/img/svg/pdf-view.svg';
    pdfLoading = false;
    link: string | null = null;
    constructor(
        private hs: HistoryService,
        @Inject(MAT_DIALOG_DATA) public dataIN: any,
        private sanitizer: DomSanitizer,
        private alert: AlertService,
    ) {
        //
        if (dataIN && dataIN.type && dataIN.id) {
            this.historyId = dataIN.id;
            this.historyType = dataIN.type;
        }
    }

    ngOnInit(): void {
        this.GetItem(this.historyId);
    }

    GetItem(id: number) {
        this.hs
            .getHistoryItem({
                id: this.historyId,
                typeHistory: this.historyType,
            })
            .subscribe(
                (res) => {
                    if (
                        Array.isArray(res) &&
                        res[0]?.link_or_html_flag === 'link'
                    ) {
                        this.link = res[0].text ?? '';
                        return;
                    }
                    this.resHtml = res.reduce((acc, item) => {
                        if (!item.text || item.text == 'null') return acc;
                        acc = acc + item.text;
                        return acc;
                    }, '');
                    this.resHtml = this.sanitizer.bypassSecurityTrustHtml(
                        this.resHtml as string
                    );
                },
                (err) => {
                    console.error('getHistoryItem ERRROr=', err);
                }
            );
    }

    public gotToDownload(link: string, $event: MouseEvent) {
        $event.stopPropagation();
        this.pdfLoading = true;
        this.hs.getApiPdf(link).subscribe({
            next: (blob) => {
                this.pdfLoading = false;
                if (typeof blob === 'string') {
                    const binaryString = atob(blob);
                    const bytes = new Uint8Array(binaryString.length);
                    for (let i = 0; i < binaryString.length; i++) {
                        bytes[i] = binaryString.charCodeAt(i);
                    }
                    const file = new Blob([bytes.buffer], {
                        type: 'application/pdf',
                    });
                    const fileURL = URL.createObjectURL(file);
                    window.location.href = fileURL;

                    setTimeout(() => URL.revokeObjectURL(fileURL), 10000);
                } else {
                    console.error(blob);
                    this.alert.error(`Ошибка загрузки, ${blob.message}`);
                }
            },
            error: (error) => {
                this.pdfLoading = false;
                console.error(error);
            },
        });
    }
}
